import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';
import { LightParagraph, SmallTitle } from './typography/Typography';

const Container = styled.div`
  border: 1px solid #ededfb;
  border-radius: 6px;
  padding: 16px 21px;
`;

const TopItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
`;

const ChargeType = styled.div`
  color: #5d6ef8;
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
`;

const ChargeName = styled(SmallTitle)`
  margin-left: 14px;
`;

const ChargePrice = styled.div`
  font-size: 14px;
`;

type Props = {
  chargeType: string;
  title: string;
  description: string;
  chargePrice: number;
  currency: string;
};

function PricingCard({
  chargeType,
  title,
  description,
  chargePrice,
  currency,
}: Props) {
  const formattedPrice = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 20,
  }).format(chargePrice);
  return (
    <Container>
      <TopItems>
        <Title>
          <ChargeType>{chargeType}</ChargeType>
          <ChargeName>{title}</ChargeName>
        </Title>
        <ChargePrice>{chargePrice > 0 ? formattedPrice : 'Free'}</ChargePrice>
      </TopItems>
      <Spacer vertical spacing={1} />
      <LightParagraph>{description}</LightParagraph>
    </Container>
  );
}

export default PricingCard;
